export const categories = [
  { slug: 'rexue', name: '热血', icon: 'ri-fire-line' },
  { slug: 'lianai', name: '恋爱', icon: 'ri-heart-line' },
  { slug: 'gaoxiao', name: '搞笑', icon: 'ri-emotion-laugh-line' },
  { slug: 'xuanyi', name: '悬疑', icon: 'ri-search-eye-line' },
  { slug: 'qihuan', name: '奇幻', icon: 'ri-magic-line' },
  { slug: 'dushi', name: '都市', icon: 'ri-building-line' },
  { slug: 'gufeng', name: '古风', icon: 'ri-ink-bottle-line' },
  { slug: 'kehuan', name: '科幻', icon: 'ri-rocket-line' },
];

export const comics = [
  {
    id: 1,
    title: '洞洞杂货铺',
    author: '墨染星河',
    category: 'qihuan',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Chinese%20manhua%20manga%20style%20illustration%20of%20a%20mysterious%20grocery%20store%20at%20night%20with%20warm%20lighting%2C%20magical%20items%20floating%20around%2C%20a%20young%20shopkeeper%20with%20gentle%20expression%2C%20soft%20watercolor%20texture%2C%20dreamy%20atmosphere%2C%20clean%20simple%20background&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    description: '在一家不起眼的杂货铺里，藏着连接不同世界的秘密。少年店主林洞洞与每一位走进店里的客人，都会开启一段不可思议的冒险。',
    status: '连载中',
    rating: 9.6,
    views: 1280000,
    chapters: 186,
    updatedAt: '2026-08-03',
    featured: true,
  },
  {
    id: 2,
    title: '星辰大海',
    author: '七月流火',
    category: 'kehuan',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20sci-fi%20illustration%20of%20a%20young%20astronaut%20floating%20in%20space%20with%20stars%20and%20galaxies%2C%20dreamy%20nebula%20colors%2C%20clean%20watercolor%20style%2C%20soft%20ethereal%20atmosphere%2C%20simple%20composition%20on%20light%20background&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    description: '公元2150年，人类已经踏足银河系的每一个角落。年轻的星际探险家苏辰，在一次例行任务中发现了一个足以改变人类命运的古老秘密。',
    status: '连载中',
    rating: 9.4,
    views: 890000,
    chapters: 142,
    updatedAt: '2026-08-02',
    featured: true,
  },
  {
    id: 3,
    title: '青梅小调',
    author: '糖炒栗子',
    category: 'lianai',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20romance%20manhua%20illustration%20of%20two%20teenagers%20sitting%20under%20cherry%20blossom%20tree%2C%20school%20uniforms%2C%20gentle%20spring%20atmosphere%2C%20soft%20pink%20tones%2C%20clean%20watercolor%20style%2C%20simple%20light%20background&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    description: '从小一起长大的青梅竹马，在高中时代终于察觉了彼此的心意。一段关于青春、成长与初恋的甜蜜故事。',
    status: '已完结',
    rating: 9.7,
    views: 2150000,
    chapters: 96,
    updatedAt: '2026-06-15',
    featured: true,
  },
  {
    id: 4,
    title: '斗神纪元',
    author: '狂风卷云',
    category: 'rexue',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20action%20manhua%20illustration%20of%20a%20powerful%20martial%20artist%20in%20dynamic%20battle%20pose%2C%20energy%20effects%20surrounding%2C%20ancient%20Chinese%20fantasy%20theme%2C%20warm%20golden%20lighting%2C%20clean%20illustration%20style%2C%20simple%20dark%20background&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    description: '在这个以武为尊的世界里，少年江辰从一介废材逆天崛起，踏上了一条通往最强斗神的传奇之路。',
    status: '连载中',
    rating: 9.3,
    views: 3500000,
    chapters: 320,
    updatedAt: '2026-08-04',
    featured: true,
  },
  {
    id: 5,
    title: '深夜食堂诡谈',
    author: '暗夜行者',
    category: 'xuanyi',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20mystery%20horror%20manhua%20illustration%20of%20a%20dimly%20lit%20late-night%20restaurant%20with%20mysterious%20shadows%2C%20atmospheric%20fog%2C%20warm%20but%20eerie%20lighting%2C%20clean%20watercolor%20style%2C%20simple%20dark%20background&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    description: '只在午夜开门的神秘食堂，每一位客人都带着自己无法释怀的故事而来。而食堂老板似乎知道每个人深藏的秘密……',
    status: '连载中',
    rating: 9.5,
    views: 1560000,
    chapters: 78,
    updatedAt: '2026-08-01',
    featured: false,
  },
  {
    id: 6,
    title: '武林外史新编',
    author: '江湖故人',
    category: 'gufeng',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20ancient%20martial%20arts%20manhua%20illustration%20of%20a%20swordsman%20in%20traditional%20hanfu%20standing%20on%20mountain%20peak%2C%20misty%20landscape%2C%20ink%20wash%20painting%20style%2C%20elegant%20composition%2C%20simple%20light%20background&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    description: '江湖不是打打杀杀，江湖是人情世故。一部重新演绎的武林传奇，带你领略真正的大唐江湖。',
    status: '连载中',
    rating: 9.2,
    views: 980000,
    chapters: 156,
    updatedAt: '2026-07-30',
    featured: false,
  },
  {
    id: 7,
    title: '办公室物语',
    author: '写字楼小K',
    category: 'gaoxiao',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20office%20slice-of-life%20manhua%20illustration%2C%20funny%20exaggerated%20office%20workers%20expressions%2C%20bright%20warm%20colors%2C%20clean%20cartoon%20style%2C%20simple%20white%20background&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    description: '社畜的日常有多心酸就有多好笑！一群年轻人在写字楼里的爆笑生存指南，每一页都是职场人的真实写照。',
    status: '连载中',
    rating: 9.1,
    views: 2100000,
    chapters: 210,
    updatedAt: '2026-08-03',
    featured: true,
  },
  {
    id: 8,
    title: '都市灵探',
    author: '迷雾之眼',
    category: 'dushi',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20urban%20supernatural%20manhua%20illustration%20of%20a%20detective%20in%20modern%20city%20at%20night%2C%20neon%20lights%20reflection%2C%20mysterious%20atmosphere%2C%20clean%20watercolor%20style%2C%20simple%20dark%20background&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    description: '在现代都市的霓虹灯下，隐藏着不为人知的超自然事件。私家侦探顾北与他的灵异伙伴，穿梭于现实与灵界之间。',
    status: '连载中',
    rating: 9.0,
    views: 670000,
    chapters: 64,
    updatedAt: '2026-07-28',
    featured: false,
  },
  {
    id: 9,
    title: '仙界快递员',
    author: '飞天小猪',
    category: 'qihuan',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20comedy%20manhua%20illustration%20of%20a%20delivery%20boy%20riding%20a%20flying%20sword%20in%20clouds%2C%20magical%20items%2C%20bright%20warm%20sunlight%2C%20clean%20illustration%20style%2C%20simple%20sky%20background&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    description: '普通快递小哥意外获得修仙能力后，成为了三界唯一的快递员。给玉帝送外卖，帮嫦娥带快递，这日子也太刺激了！',
    status: '连载中',
    rating: 9.8,
    views: 4200000,
    chapters: 256,
    updatedAt: '2026-08-04',
    featured: true,
  },
  {
    id: 10,
    title: '深渊之下',
    author: '深海恐惧',
    category: 'xuanyi',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20thriller%20manhua%20illustration%20of%20deep%20ocean%20abyss%20with%20faint%20light%20from%20above%2C%20mysterious%20creature%20silhouette%2C%20atmospheric%20dark%20blue%20tone%2C%20clean%20watercolor%20style%2C%20simple%20background&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    description: '一支深海科考队在万米深渊之下，发现了一个不应该存在的东西。从那一刻起，所有人的命运都被改写了。',
    status: '连载中',
    rating: 9.3,
    views: 780000,
    chapters: 45,
    updatedAt: '2026-07-25',
    featured: false,
  },
  {
    id: 11,
    title: '花间醉',
    author: '水墨青花',
    category: 'gufeng',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20romance%20manhua%20illustration%20of%20beautiful%20woman%20in%20traditional%20hanfu%20among%20peach%20blossoms%2C%20ancient%20Chinese%20garden%2C%20soft%20pastel%20colors%2C%20elegant%20watercolor%20style%2C%20simple%20light%20background&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    description: '她是京城最有名的花魁，却有着不为人知的身世。当朝堂风云与儿女情长交织，一曲花间醉，道尽世间悲欢离合。',
    status: '已完结',
    rating: 9.6,
    views: 1890000,
    chapters: 120,
    updatedAt: '2026-05-20',
    featured: false,
  },
  {
    id: 12,
    title: '学霸的逆袭',
    author: '方程式',
    category: 'dushi',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20school%20life%20manhua%20illustration%20of%20a%20student%20studying%20under%20desk%20lamp%2C%20books%20and%20papers%2C%20warm%20cozy%20lighting%2C%20clean%20illustration%20style%2C%20simple%20background&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    description: '从年级倒数到高考状元，这不是天才的故事，而是一个普通人的奋斗史。当你拼尽全力时，整个世界都会为你让路。',
    status: '已完结',
    rating: 9.4,
    views: 3200000,
    chapters: 88,
    updatedAt: '2026-04-10',
    featured: false,
  },
];

export const latestUpdates = [
  { id: 1, comicTitle: '洞洞杂货铺', chapterTitle: '第186话 门后的世界', time: '2小时前' },
  { id: 4, comicTitle: '斗神纪元', chapterTitle: '第320话 巅峰对决', time: '3小时前' },
  { id: 9, comicTitle: '仙界快递员', chapterTitle: '第256话 三界大战', time: '5小时前' },
  { id: 7, comicTitle: '办公室物语', chapterTitle: '第210话 年终奖之夜', time: '6小时前' },
  { id: 5, comicTitle: '深夜食堂诡谈', chapterTitle: '第78话 最后一碗面', time: '8小时前' },
  { id: 2, comicTitle: '星辰大海', chapterTitle: '第142话 银河尽头', time: '10小时前' },
  { id: 6, comicTitle: '武林外史新编', chapterTitle: '第156话 华山论剑', time: '12小时前' },
  { id: 8, comicTitle: '都市灵探', chapterTitle: '第64话 镜中人', time: '1天前' },
  { id: 10, comicTitle: '深渊之下', chapterTitle: '第45话 深海回响', time: '1天前' },
  { id: 3, comicTitle: '青梅小调', chapterTitle: '第96话 永远在一起（终）', time: '2天前' },
  { id: 11, comicTitle: '花间醉', chapterTitle: '第120话 花开有时（终）', time: '3天前' },
  { id: 12, comicTitle: '学霸的逆袭', chapterTitle: '第88话 新的起点（终）', time: '5天前' },
];

export const banners = [
  {
    id: 1,
    comicId: 9,
    title: '仙界快递员',
    subtitle: '年度最受欢迎奇幻漫画',
    description: '普通快递小哥的修仙之旅，笑中带泪的奇幻冒险',
    image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Chinese%20manhua%20style%20fantasy%20illustration%2C%20a%20delivery%20boy%20riding%20a%20flying%20sword%20through%20clouds%2C%20magical%20celestial%20palace%20in%20background%2C%20warm%20golden%20sunlight%2C%20dreamy%20atmosphere%2C%20ink%20wash%20and%20watercolor%20fusion%20style%2C%20ethereal%20clouds&width=1600&height=700&seq=banner-01&orientation=landscape',
  },
  {
    id: 2,
    comicId: 4,
    title: '斗神纪元',
    subtitle: '热血战斗 燃爆全场',
    description: '废材少年逆天崛起，踏上最强斗神之路',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20action%20manhua%20epic%20battle%20scene%2C%20powerful%20martial%20artist%20with%20energy%20aura%2C%20dramatic%20sky%20with%20golden%20light%2C%20ancient%20Chinese%20fantasy%20landscape%2C%20dynamic%20composition%2C%20warm%20heroic%20atmosphere&width=1600&height=700&seq=banner-02&orientation=landscape',
  },
  {
    id: 3,
    comicId: 3,
    title: '青梅小调',
    subtitle: '甜蜜完结 口碑佳作',
    description: '青梅竹马的纯爱故事，唤醒你的青春记忆',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20romance%20manhua%20scene%2C%20two%20teenagers%20walking%20under%20cherry%20blossom%20trees%20in%20spring%2C%20sunlight%20filtering%20through%20petals%2C%20warm%20gentle%20colors%2C%20nostalgic%20school%20setting%2C%20watercolor%20texture%2C%20dreamy%20atmosphere&width=1600&height=700&seq=banner-03&orientation=landscape',
  },
];